import { LISTING_STATUS_LABELS, type ListingStatus } from '@/api/listings'
import { Badge, type BadgeTone } from '@/design'

const TONE: Record<ListingStatus, BadgeTone> = {
  draft: 'neutral',
  content_drafted: 'info',
  approved: 'accent',
  published: 'positive',
  needs_republish: 'warning',
}

export function ListingStatusBadge({ status }: { status: ListingStatus }) {
  return <Badge tone={TONE[status]}>{LISTING_STATUS_LABELS[status]}</Badge>
}
